/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:16:48
 * @LastEditTime: 2021-08-18 16:19:16
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\calculate.js
 * 这锅我不背
 */
import Big from "big.js";

import operate from "./operate";
import { isNumber } from "./utils";

const EMPTY = {
    key: '',
    prev: {
        value: '',
        operation: '',
        formula: '',
        result: 0,
    },
    result: 0,
    next: {
        value: '',
        operation: '',
        formula: '',
        result: 0,
    },
    operation: '',
    formula: '',
    process: [],
    input: [],
    isEqual: false,
};

/**
 * 计算器的计算规则
 * @ignore
 * @memberof Calculator
 * @param {string} old 
 * @param {string} key 
 * @returns {object}
 */
export default function calculate(old, key) {
    // 当前视图
    let view = {
        ...EMPTY,
        key,
        ...old,
    };

    // 清空
    if (key === "C") {
        return { ...EMPTY, process: old.process };
    }

    // 纠错
    if (key === "CE") {
        // 有计算公式  去除后面一组元素
        if (old.operation) {
            view.next = {
                value: '',
                operation: '',
                formula: '',
                result: 0,
            };
            view.result = view.prev.result;
            view.formula = view.prev.formula + old.operation;
            return view;
        } else {
            // 清空
            return { ...EMPTY, process: old.process };
        }
    }

    // 移除
    if (key === "BS") {
        // 等于之后不能移除
        if (old.isEqual) {
            return view;
        }

        // 移除
        view.input.pop();

        if (old.operation) {
            // 有单元运算之后不能移除
            if (old.next.operation) {
                return view;
            }

            // 说明只有操作符了，移除操作符
            if (old.next.value === '') {
                view.next = {
                    value: '',
                    operation: '',
                    formula: '',
                    result: 0,
                };
                view.result = view.prev.result;
                view.formula = view.prev.formula;
                view.operation = '';
                return view;
            }

            // 移除一个字符
            view.next.value = old.next.value.substring(0, old.next.value.length - 1);
            view.next.result = view.next.value;
            view.next.formula = view.next.value;

            view.formula = view.prev.formula + view.operation + view.next.formula;
            // 走四则运算
        } else {
            // 有单元运算之后不能移除
            if (old.prev.operation) {
                return view;
            }

            view.prev.value = old.prev.value.substring(0, old.prev.value.length - 1);
            view.prev.result = view.prev.value || 0;
            view.prev.formula = view.prev.value;

            view.result = view.prev.result;
            view.formula = view.prev.formula;
            return view;
        }
    }

    if (key === 'MS') {
        // 有操作符 存储不起作用
        if (!old.operation) {
            view.mStore = view.prev.result;
        }
        return view;
    }

    if (key === 'MR') {
        // 有操作符 存储不起作用
        if (old.operation) {
            // 用例里写的时不起作用  我也没辙
            // return view;
            view.next = {
                value: view.mStore,
                operation: '',
                formula: view.mStore,
                result: view.mStore,
            };
            view.formula = view.prev.formula + old.operation + view.next.formula;
        } else {
            view.prev = {
                value: view.mStore,
                operation: '',
                formula: view.mStore,
                result: view.mStore,
            };
            view.result = view.prev.result;
            view.formula = view.prev.formula + old.operation;
            return view;
        }
    }

    if (key === 'MC') {
        view.mStore = '';
        return view;
    }

    if (key === 'M+') {
        view.mStore = operate(view.mStore, !old.operation ? view.prev.result : view.next.result, '+');
        return view;
    }

    // 输入的是数值
    if (isNumber(key)) {
        if (view.isEqual) {
            view.isEqual = false;
            // 初始化
            old = view = { ...EMPTY, process: old.process };
        }

        if (old.operation) {
            // 上一个元素
            view.prev = old.prev;
            // 操作符及操作之前的值
            view.operation = old.operation;

            // 替换原来的数值（方案一）
            if (old.next.operation) {
                view.next = {
                    value: key,
                    operation: '',
                    formula: key,
                    result: key,
                }
            } else {
                let value = old.next.value === "0" || !old.next.value ? key : old.next.value + key;

                view.next = {
                    value: value,
                    operation: '',
                    formula: value,
                    result: value,
                }
            }

        } else {
            // 只有前一个元素
            // 替换原来的数值（方案一）
            if (old.prev.operation) {
                view.prev = {
                    value: key,
                    operation: '',
                    formula: key,
                    result: key,
                }
            } else {
                let value = old.prev.value === "0" || !old.prev.value ? key : old.prev.value + key;
                view.prev = {
                    value: value,
                    operation: '',
                    formula: value,
                    result: value,
                }
            }

            // 前
            view.result = view.prev.result;
        }

        // 计算过程
        view.formula = view.prev.formula + old.operation + view.next.formula;
        // 录入过程
        view.input.push(key);

        // 下面可能还有四则运算  所以不return;
    } else {
        // 没有prev 不能输入
        if (old.prev.value === '') {
            return view;
        }

        // if (view.isEqual) {
        //     view.isEqual = false;

        // }

        switch (key) {
            case 'BS':
            case 'MR':
                // 过麦
                break;
            case '.':
                // 前一次操作时等号
                if (view.isEqual) {
                    old.prev = {
                        formula: old.result,
                        value: old.result,
                        operate: '',
                        result: old.result,
                    };
                    view.next = {
                        formula: '',
                        value: '',
                        operate: '',
                        result: 0,
                    };
                    old.operation = '';
                    view.operation = '';
                    view.isEqual = false;
                }
                if (old.operation) {
                    if (old.next.value.indexOf('.') !== -1) {
                        return view;
                    }
                    if (old.next.operation) {
                        view.next = {
                            value: '0.',
                            operation: '',
                            formula: '0.',
                            result: 0,
                        }
                    } else {
                        let value = old.next.value === "0" || !old.next.value ? '0.' : old.next.value + key;
                        view.next = {
                            value: value,
                            operation: '',
                            formula: value,
                            result: old.next.value || 0,
                        }
                    }
                } else {
                    if (old.prev.value.indexOf('.') !== -1) {
                        return view;
                    }
                    if (old.prev.operation) {
                        view.prev = {
                            value: '0.',
                            operation: '',
                            formula: '0.',
                            result: 0,
                        }
                    } else {
                        let value = old.prev.value === "0" || !old.prev.value ? '0.' : old.prev.value + key;
                        view.prev = {
                            value: value,
                            operation: '',
                            formula: value,
                            result: old.prev.value || 0,
                        }
                    }
                }

                view.formula = view.prev.formula + old.operation + view.next.formula;
                view.result = old.result;
                view.input.push(key);
                return view;
            case 'sqrt':
                // 前一次操作时等号
                if (view.isEqual) {
                    old.prev = {
                        formula: old.result,
                        value: old.result,
                        operate: '',
                        result: old.result,
                    };
                    view.next = {
                        formula: '',
                        value: '',
                        operate: '',
                        result: 0,
                    };
                    old.operation = '';
                    view.operation = '';
                    view.isEqual = false;
                }

                if (old.operation) {
                    // 如果没有数值 不起作用
                    if (old.next.value === '') {
                        return view;
                    }
                    let value = old.next.result === "0" || !old.next.result ? 0 : old.next.result;
                    view.next.value = old.next.result;
                    view.next.result = operate(value, undefined, 'sqrt');
                    view.next.operation = key;
                    view.next.formula = `√(${old.next.formula || 0})`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    // 再进行四则运算
                } else {
                    let value = old.prev.result === "0" || !old.prev.result ? 0 : old.prev.result;
                    view.prev.value = old.prev.result;
                    view.prev.result = operate(value, undefined, 'sqrt');
                    view.prev.operation = key;
                    view.prev.formula = `√(${old.prev.formula || 0})`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    view.result = view.prev.result;
                    view.input.push(key);
                    view.process.push({
                        formula: view.formula,
                        result: view.result,
                    });
                    // 不进行四则运算
                    return view;
                }
                break;
            case '%':
                // 前一次操作时等号
                if (view.isEqual) {
                    old.prev = {
                        formula: old.result,
                        value: old.result,
                        operate: '',
                        result: old.result,
                    };
                    view.next = {
                        formula: '',
                        value: '',
                        operate: '',
                        result: 0,
                    };
                    view.operation = '';
                    view.isEqual = false;
                }
                if (old.operation) {
                    // 如果没有数值 不起作用
                    if (old.next.value === '') {
                        return view;
                    }
                    let value = old.next.result === "0" || !old.next.result ? 0 : old.next.result;
                    view.next.value = old.next.result;
                    view.next.result = operate(value, 100, '÷');
                    view.next.operation = key;
                    view.next.formula = `${old.next.formula || 0}%`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    // 再进行四则运算
                } else {
                    let value = old.prev.result === "0" || !old.prev.result ? 0 : old.prev.result;
                    view.prev.value = old.prev.result;
                    view.prev.result = operate(value, 100, '÷');
                    view.prev.operation = key;
                    view.prev.formula = `${old.prev.formula || 0}%`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    view.result = view.prev.result;
                    view.input.push(key);
                    view.process.push({
                        formula: view.formula,
                        result: view.result,
                    });
                    // 不进行四则运算
                    return view;
                }
                break;
            case 'x/x':
                // 前一次操作时等号
                if (view.isEqual) {
                    old.prev = {
                        formula: old.result,
                        value: old.result,
                        operate: '',
                        result: old.result,
                    };
                    view.next = {
                        formula: '',
                        value: '',
                        operate: '',
                        result: 0,
                    };
                    old.operation = '';
                    view.operation = '';
                    view.isEqual = false;
                }
                if (old.operation) {
                    // 如果没有数值 不起作用
                    if (old.next.value === '') {
                        return view;
                    }
                    let value = old.next.result === "0" || !old.next.result ? 0 : old.next.result;
                    view.next.value = old.next.result;
                    view.next.result = operate(1, value, '÷');
                    view.next.operation = key;
                    view.next.formula = `1/(${value})`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    // 再进行四则运算
                } else {
                    let value = old.prev.result === "0" || !old.prev.result ? 0 : old.prev.result;
                    view.prev.value = old.prev.result;
                    view.prev.result = operate(1, value, '÷');
                    view.prev.operation = key;
                    view.prev.formula = `1/(${value})`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    view.result = view.prev.result;
                    view.input.push(key);
                    view.process.push({
                        formula: view.formula,
                        result: view.result,
                    });
                    // 不进行四则运算
                    return view;
                }
                break;
            case '+/-':
                // 前一次操作时等号
                if (view.isEqual) {
                    old.prev = {
                        formula: old.result,
                        value: old.result,
                        operate: '',
                        result: old.result,
                    };
                    view.next = {
                        formula: '',
                        value: '',
                        operate: '',
                        result: 0,
                    };
                    old.operation = '';
                    view.operation = '';
                    view.isEqual = false;
                }

                if (old.operation) {
                    // 如果没有数值 不起作用
                    if (old.next.value === '') {
                        return view;
                    }
                    let value = old.next.result === "0" || !old.next.result ? 0 : old.next.result;
                    view.next.value = old.next.result;
                    view.next.result = operate(value, undefined, '+/-');
                    view.next.operation = key;
                    view.next.formula = `${view.next.result || 0}`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    // 再进行四则运算
                } else {
                    let value = old.prev.result === "0" || !old.prev.result ? 0 : old.prev.result;
                    view.prev.value = old.prev.result;
                    view.prev.result = operate(value, undefined, '+/-');
                    view.prev.operation = key;
                    view.prev.formula = `${view.prev.result || 0}`;
                    view.formula = view.prev.formula + old.operation + view.next.formula;
                    view.result = view.prev.result;
                    view.input.push(key);
                    // 不进行四则运算
                    return view;
                }
                break;
            case '=':
                // 清空过程
                view.input = [];
                view.isEqual = true;

                // 清理一下如果只输入了1. 或者  1.2+1.的情况
                if (view.prev.value.indexOf('.') !== -1 && view.prev.value === view.prev.result + '.') {
                    view.prev.operation = '';
                    view.prev.formula = view.prev.result;
                    view.prev.value = view.prev.result;
                }

                if (view.next.value.indexOf('.') !== -1 && view.next.value === view.next.result + '.') {
                    view.next.operation = '';
                    view.next.formula = view.next.result;
                    view.next.value = view.next.result;
                }
                
                if (old.operation) {
                    if (view.next.value === '') {
                        view.next = { ...view.prev };
                    }

                    view.formula = view.prev.formula + old.operation + view.next.formula;

                    // 再进行四则运算
                } else {
                    view.operation = '';

                    let value = old.prev.result === "0" || !old.prev.result ? 0 : old.prev.result;

                    view.prev.value = old.prev.result;
                    view.prev.result = value;
                    view.prev.operation = '';
                    view.prev.formula = `${old.prev.formula || 0}`;

                    view.formula = view.prev.formula;
                    view.result = view.prev.result;

                    view.process.push({
                        formula: view.formula,
                        result: view.result,
                    });
                    // 不进行四则运算
                    return view;
                }
                break;
            default:
                // 多元运算
                if (old.operation) {
                    if (old.next.value === '') {
                        // 多元情况 next为空，替换操作符

                        view.operation = key;
                        view.formula = old.prev.formula + key;
                        view.input.push(key);
                    } else {
                        // 如果已经计算，这把计算结果放到历史记录中

                        view.operation = key;

                        view.process.push({
                            result: view.result,
                            formula: view.formula,
                        });

                        view.prev = {
                            formula: view.result,
                            value: view.result,
                            operate: '',
                            result: view.result,
                        };

                        view.next = {
                            formula: '',
                            value: '',
                            operate: '',
                            result: 0,
                        };

                        view.formula = view.prev.formula + view.operation + view.next.formula;
                    }
                } else {
                    view.operation = key;
                    view.formula = view.prev.formula + key;
                    view.input.push(key);
                }
                return view;
        }
    }

    // 进行四则运算
    if (view.operation) {
        // 进行运算
        let res = operate(view.prev.result, view.next.result, view.operation);
        view.input.push(key);
        if (view.isEqual || key === 'sqrt' || key === '%' || key === 'x/x') {
            view.process.push({
                formula: view.formula,
                result: res,
            });
        }
        return {
            ...view,
            result: res,
        };
    }

    return view;
}
